import * as yup from 'yup';
import { stringSchema } from 'utils/validation';

export const rules = yup.object().shape({
  projectName: stringSchema({ label: 'Project name', max: 240 }),
});
